import { Background, Border, BorderRadius, BorderStyle, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";
import type { IWithIsMobile } from "../../interfaces/IWithIsMobile.interface";
import { MAX_WIDTH_INNER_PAGE_CONTAINER } from "../../theme/style.constants";

const QUESTIONNAIRE_COMPLETED_SECTION_MIN_WIDTH = "15rem";

export const CARD_RECAP_PAPER_PADDING = `${Spacing["5000"]} ${Spacing["8000"]}`;
export const MOBILE_CARD_RECAP_PAPER_PADDING = `${Spacing["3000"]} ${Spacing["2000"]}`;

export const CardRecapPaper = styled(Paper)<IWithIsMobile>(({ isMobile }) => ({
  background: Background.paper,
  borderRadius: BorderRadius.paper,
  border: `1px ${BorderStyle.solid} ${Border.main}`,
  padding: isMobile ? MOBILE_CARD_RECAP_PAPER_PADDING : CARD_RECAP_PAPER_PADDING,
  width: "100%",
  minWidth: QUESTIONNAIRE_COMPLETED_SECTION_MIN_WIDTH,
  maxWidth: MAX_WIDTH_INNER_PAGE_CONTAINER,
}));
